module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<fieldset class="cw-fieldset phx-populations-detail">\r\n  <div class="phx-populations-menu-popup form-group">\r\n    <label for="nom" class="cw-required"></label>\r\n    <span class="cmbCollab"></span>\r\n    <br><br>\r\n    <button type="button" class="buttonAppliquer btn btn-primary" >'+
((__t=(i18n.t("populationsmenu.appliquer")))==null?'':__t)+
'</button>\r\n  </div>\r\n</fieldset>\r\n';
}
return __p;
};
